import VueRouter from 'vue-router'
import routes, { authGuard } from './routes'

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && to.path !== '/register') {
    authGuard(to, from, next)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./resources/assets/js/router.js